import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  playCourseIntroductionVideo: {
    id: 'category.course-about.course-intro.course-media.play-course-introduction-video',
    defaultMessage: 'Play course introduction video',
    description: 'The text for the button to play the course introduction video.',
  },
});

export default messages;
